import { c as _c } from "react/compiler-runtime";
import React from "react";
import { SingleWaveDropTab } from "./SingleWaveDrop";
interface SingleWaveDropTabsProps {
  readonly activeTab: SingleWaveDropTab;
  readonly setActiveTab: (tab: SingleWaveDropTab) => void;
}
export const SingleWaveDropTabs: React.FC<SingleWaveDropTabsProps> = t0 => {
  const $ = _c(19);
  const {
    activeTab,
    setActiveTab
  } = t0;
  const t1 = activeTab === SingleWaveDropTab.INFO ? "tw-p-[1px] tw-flex tw-rounded-lg tw-bg-gradient-to-b tw-from-primary-500/20 tw-to-primary-600/20" : "tw-p-[1px] tw-flex tw-rounded-lg";
  let t2;
  if ($[0] !== setActiveTab) {
    t2 = () => setActiveTab(SingleWaveDropTab.INFO);
    $[0] = setActiveTab;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `tw-whitespace-nowrap tw-flex-1 tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-border-0 tw-rounded-lg tw-transition-all tw-duration-300 tw-ease-out ${activeTab === SingleWaveDropTab.INFO ? "tw-bg-primary-500/10 tw-text-primary-300" : "tw-bg-iron-950 desktop-hover:hover:tw-bg-primary-500/5 tw-text-iron-400 desktop-hover:hover:tw-text-primary-300"}`;
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <button onClick={t2} className={t3}>Drop</button>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1 || $[6] !== t4) {
    t5 = <div className={t1}>{t4}</div>;
    $[5] = t1;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = activeTab === SingleWaveDropTab.CHAT ? "tw-p-[1px] tw-flex tw-rounded-lg tw-bg-gradient-to-b tw-from-primary-500/20 tw-to-primary-600/20" : "tw-p-[1px] tw-flex tw-rounded-lg";
  let t7;
  if ($[8] !== setActiveTab) {
    t7 = () => setActiveTab(SingleWaveDropTab.CHAT);
    $[8] = setActiveTab;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = `tw-whitespace-nowrap tw-flex-1 tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-border-0 tw-rounded-lg tw-transition-all tw-duration-300 tw-ease-out ${activeTab === SingleWaveDropTab.CHAT ? "tw-bg-primary-500/10 tw-text-primary-300" : "tw-bg-iron-950 desktop-hover:hover:tw-bg-primary-500/5 tw-text-iron-400 desktop-hover:hover:tw-text-primary-300"}`;
  let t9;
  if ($[10] !== t7 || $[11] !== t8) {
    t9 = <button onClick={t7} className={t8}>Discussion</button>;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t6 || $[14] !== t9) {
    t10 = <div className={t6}>{t9}</div>;
    $[13] = t6;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t5) {
    t11 = <div className="lg:tw-hidden tw-w-full tw-px-4 tw-py-2 tw-bg-iron-950 tw-border-b tw-border-solid tw-border-iron-800 tw-border-x-0 tw-border-t-0"><div className="tw-p-0.5 tw-relative tw-ring-1 tw-ring-inset tw-bg-iron-950/90 tw-ring-primary-800/20 tw-inline-flex tw-rounded-lg tw-w-auto tw-gap-x-0.5">{t5}{t10}</div></div>;
    $[16] = t10;
    $[17] = t5;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
};